import { useContext, useEffect } from "react";
import useGetApp from "src/hooks/useGetApp";
import useGetOrg from "src/hooks/useGetOrganization";
import { useGetAppConfigurationRequest } from "src/services/organizations/queries/configuration";

import Context from "../context";

const useGetAppConfig = () => {
	const { actions } = useContext(Context);

	const org = useGetOrg();
	const app = useGetApp();
	const { data, isFetching } = useGetAppConfigurationRequest(org.id, app?.id ?? "");

	useEffect(() => {
		onSetConfig();
	}, [data]);

	const onSetConfig = () => {
		if (data) {
			actions.onSelectConfig(data?.selectionMode === "BY_STATUS" ? data?.entityStatus : "CUSTOM");
			actions.onSetForceSecureConnection(app?.forceSecureConnection ?? false);
		}
	};

	return { isLoading: isFetching };
};

export default useGetAppConfig;
